import { useState, useEffect, useContext } from "react";
import React from "react";
import useSupport from "../../../hooks/useSupport";
import { PixelContext } from '../../../context/Pixel';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "reactstrap";

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);
  const [showModal, setShowModal] = useState(false);
  const support = useSupport();
  const { MetaPixel } = useContext(PixelContext);

  useEffect(() => {
    if (support.contactMessageResponse) {
      clearState();
      setShowModal(true);
      MetaPixel.track('Contact');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [support.contactMessageResponse]);

  useEffect(() => {
    if (support.error) {
      setShowModal(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [support.error]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearState = () => setState({ ...initialState });

  const toggleModal = () => setShowModal(!showModal);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!support.loading && name && email && message) {
      support.sendContactMessage(name, email, message);
    }
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Get In Touch</h2>
                <p>
                  Please fill out the form below to send us an email and we will
                  get back to you as soon as possible.
                </p>
              </div>
              <form name="sentMessage" validate="true" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={name}
                        className="form-control"
                        placeholder="Name"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={email}
                        className="form-control"
                        placeholder="Email"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    value={message}
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button disabled={support.loading} type="submit" className="btn btn-custom btn-lg">
                  Send Message
                  {
                    support.loading &&
                    <>
                      {" "}<Spinner size="sm" />
                    </>
                  }
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      {
        <Modal isOpen={showModal} toggle={toggleModal} centered={true}>
          <ModalHeader className="mx-0 border-bottom-0" toggle={toggleModal} />
          <ModalBody>
            {
              !support.error &&
              <>
                <h3>Thank you for getting in touch!</h3>
                <br />
                <span>
                  We appreciate you contacting us.
                  <br />
                  One of our colleagues will get back in touch with you soon!
                </span>
              </>
            }
            {
              support.error &&
              <>
                <h4>We couldn't process your contact request</h4>
                <br />
                <span>
                  Please try again in a few minutes.
                  <br />
                  If the problem persists, try contacting us through our social networks.
                </span>
              </>
            }
          </ModalBody>
          <ModalFooter>
            <Button className="rounded-0" outline={true} onClick={toggleModal}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      }
    </div>
  );
};
